import React from 'react';
import clsx from 'clsx';

import './index.scss';

import SpInputTitle from "components/molecules/SpInputTitle";

const SpAccordionInput = ({
  title,
  label,
  list,
  type,
  visible,
}) => {
  return (
    <div className="SpAccordionInput">
      <div className="sp-accordion-radio-area-wrapper">
        <div className={clsx('sp-cmnt-area', { visible })}>
          <div className="arrowArea"></div>
          <div className="spCollpseAreaBackground">
            <SpInputTitle
              title={title}
              label={label}
              list={list}
              type={type}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SpAccordionInput;